import React, { useState } from 'react';
import useI18n from '../../../hooks/useI18n';
import { SupportedLanguage } from '../../../hooks/useI18n';

interface LanguageSelectorProps {
  className?: string;
  arrowImg?: string;
  showFlag?: boolean;
}

const LanguageSelector: React.FC<LanguageSelectorProps> = ({ 
  className = '', 
  arrowImg = '/arrow-bottom-white.svg',
  showFlag = true
}) => {
  const { 
    currentLanguage, 
    changeLanguage, 
    supportedLanguages
  } = useI18n();

  const [isOpen, setIsOpen] = useState(false);

  const handleLanguageChange = (language: SupportedLanguage) => {
    changeLanguage(language);
    setIsOpen(false);
  };

  const currentLanguageOption = supportedLanguages.find(lang => lang.code === currentLanguage);

  return (
    <div className={`language-selector relative ${className}`}>
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-1 px-2 py-1 text-sm focus:outline-none focus:ring-2 focus:ring-transparent focus:border-transparent md:bg-transparent md:border-transparent md:text-white"
      >
        {showFlag && currentLanguageOption?.flag && (
          <img 
            src={currentLanguageOption.flag} 
            alt={`${currentLanguageOption.name} flag`} 
            className="w-7 h-7"
          />
        )}
        
        <img 
          src={arrowImg}
          alt="arrow down" 
          className="w-6 h-6"
        />
      </button>

      {isOpen && (
        <div className="absolute top-full right-0 mt-1 bg-white border border-gray-300 rounded-md shadow-lg z-10 min-w-48">
          {supportedLanguages.map((lang) => (
            <button
              key={lang.code}
              type="button"
              onClick={() => handleLanguageChange(lang.code)}
              className={`w-full flex items-center rounded-md px-3 py-2 text-sm hover:bg-gray-100 ${
                lang.code === currentLanguage ? 'bg-blue-50 text-black' : 'text-gray-700'
              }`}
            >
              {showFlag && lang.flag && (
                <img 
                  src={lang.flag} 
                  alt={`${lang.name} flag`} 
                  className="w-5 h-5 rounded-sm mr-2"
                />
              )}
              {lang.name}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSelector;
